import React from "react";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import styles from "./Canned.module.css";
import { useLanguage } from "../i18n/LanguageContext";

const categories = [
  {
    key: "sprats",
    image: "/assets/products/canned/can_main_product_3.png",
    link: "/products/canned/sprats",
  },
  {
    key: "atlantic",
    image: "/assets/products/canned/can_main_product_5.png",
    link: "/products/canned/atlantic",
  },
  {
    key: "tomato",
    image: "/assets/products/canned/can_main_product_8.png",
    link: "/products/canned/tomato",
  },
  {
    key: "liver",
    image: "/assets/products/canned/can_main_product_9.png",
    link: "/products/canned/liver",
  },
];

const Canned = () => {
  const { t } = useLanguage();

  return (
    <Layout>
      <h2 className={styles.heading}>{t("canned.title")}</h2>

      <div className={styles.grid}>
        {categories.map((cat) => (
          <Link to={cat.link} key={cat.key} className={styles.card}>
            <h3>{t(`canned.${cat.key}.title`)}</h3>
            <p>{t(`canned.${cat.key}.description`)}</p>
          </Link>
        ))}
      </div>
    </Layout>
  );
};

export default Canned;
